import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { DomainService } from './domain';
import { SessionService } from './session';

@Injectable({
  providedIn: 'root'
})
export class DomainConfigService {

  schoolLogo = '';
  schoolName = '';
  favicon = '';

  constructor(
    private domainService: DomainService,
    private session: SessionService,
  ) {}

  async loadDomainConfig(): Promise<void> {

    const input = {
      Route: 'adms_form',
      Domain: window.location.host
    };

    try {

      const res: any = await firstValueFrom(
        this.domainService.getDomainDetails(input)
      );

      console.log('Domain Loaded:', res);

      this.schoolLogo = '/' + res?.SchoolLogo;
      this.schoolName = res?.SchoolName;
      this.favicon = '/' + res?.Favicon;

      // Persist session/domain info here as well so admission APIs always
      // have org/zone/branch even if only the initializer path runs first.
      this.session.setDomainDetails(res);
      this.session.setSession(res);

      if (res?.Token) {
        sessionStorage.setItem('token', res.Token);
      }

    } catch (error) {
      console.error('Domain load error:', error);
    }

    // IMPORTANT: always resolve
    return Promise.resolve();
  }
}
